export const normalizeCategoryGroupKey = (value) => (
  String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[-_]+/g, ' ')
    .replace(/\s+/g, ' ')
);

export const EXCLUDED_CATEGORY_GROUP_KEY = 'excluded';
export const INCOME_CATEGORY_GROUP_KEY = 'income';

export const getCategoryGroupKey = (groupOrName) => {
  if (typeof groupOrName === 'string') {
    return normalizeCategoryGroupKey(groupOrName);
  }

  return normalizeCategoryGroupKey(
    groupOrName?.key
    || groupOrName?.name
    || groupOrName?.label
    || groupOrName?.parent?.name
  );
};

export const isExcludedCategoryGroup = (groupOrName) => (
  getCategoryGroupKey(groupOrName) === EXCLUDED_CATEGORY_GROUP_KEY
);

export const isIncomeCategoryGroup = (groupOrName) => (
  getCategoryGroupKey(groupOrName) === INCOME_CATEGORY_GROUP_KEY
);

export const isSpendCategoryGroup = (groupOrName) => {
  const key = getCategoryGroupKey(groupOrName);
  return Boolean(key)
    && key !== EXCLUDED_CATEGORY_GROUP_KEY
    && key !== INCOME_CATEGORY_GROUP_KEY;
};
